<template>
  <div v-bind="$attrs">
    <v-menu
      offset-y
      :close-on-content-click="true"
    >
      <template #activator="{ props }">
        <div>
          <div
            class="button-wrapper"
            v-bind="props"
          >
            <v-btn
              :elevation="0"
              class="first-button zamg-button-outline-primary"
              :data-testid="`${testId}-tool-selection`"
              min-width="30px"
              width="30px"
              height="32px"
              @click.stop="handleButtonClick"
            >
              <v-icon
                v-if="selectedItem"
                :icon="selectedItem?.icon"
              />
            </v-btn>
            <v-btn
              :elevation="0"
              :data-testid="`${testId}-tool-selection-dropdown`"
              class="second-button zamg-button-outline-primary"
              min-width="20px"
              width="20px"
              height="32px"
            >
              <v-icon color="primary">
                mdi-chevron-down
              </v-icon>
            </v-btn>
          </div>
        </div>
      </template>
      <v-list
        density="compact"
        class="mt-1"
      >
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
          :data-testid="item.testId"
          @click="handleItemChange(i)"
        >
          <template #prepend>
            <v-icon :icon="item.icon" />
          </template>
          <v-list-item-title>
            {{ item.value }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, PropType } from "vue";

// TODO: use separate file
export interface ToolItem {
  value: string;
  testId: string;
  icon: string;
  callback: CallableFunction;
}

export default defineComponent({
  name: "ToolButtonWithMenu",
  props: {
    items: { type: Array as PropType<ToolItem[]>, required: true },
    testId: { type: String, required: true },
  },
  setup(props) {
    const prevIndex = ref<number | null>(null);
    const selectedItem = ref<ToolItem | null>(null);

    // TODO: I'd rather have a solution in which the client component
    // specifies the initial item via props. I couldn't make it work though
    // with @update and v-model on item group. Maybe I am stupid.
    onMounted((): void => {
      if (props.items.length !== 0) {
        selectedItem.value = props.items[0];
      }
    });

    function handleItemChange(index: number): void {
      // This is a little bit of a hack. For some reason when selecting the same
      // item in succession, the index will be undefined. We work around it by storing the previous index
      // in such cases... not optimal.
      //
      // See https://vcgitlab.zamg.ac.at/dataportal/api-management/api-frontend/-/issues/131
      if (index === undefined) {
        if (prevIndex.value !== null) {
          selectedItem.value = props.items[prevIndex.value];
          selectedItem.value.callback();
        }
        return;
      }
      selectedItem.value = props.items[index];
      selectedItem.value.callback();
      prevIndex.value = index;
    };

    function handleButtonClick(): void {
      if (selectedItem.value === null) return;
      selectedItem.value.callback();
    };

    return {
      prevIndex,
      selectedItem,
      handleItemChange,
      handleButtonClick,
    };
  },
});
</script>

<style scoped>
.button-wrapper {
  height: 32px;
}

.button-wrapper > button {
  box-shadow: none !important;
  padding: 0 !important;
}

.first-button {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}

.second-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
